module.exports = __webpack_public_path__ + "img/9788986145205.9fa50b88.jpg";